// OPA / SCT — the OPA documents screen's strings in the portal's four languages (2026-10-21). The chart cards
// keep their English in the PNG the Excel / PDF export stores (see cardPng); only the screen reads these.
const en = {
  col: {
    docNo: 'Doc',
    styleName: 'Style',
    season: 'Season',
    line: 'Line',
    plCategory: 'Category',
    category: 'Doc type',
    skuCount: 'SKUs',
    version: 'Ver',
    created: 'Created',
    createdBy: 'Created by',
    updated: 'Updated',
    updatedBy: 'Updated by',
  },
  errLoadList: 'Could not load the list',
  errSaveBlock: 'Could not save the block',
  errRemove: 'Could not remove it',
  errUpdateBlock: 'Could not update the block',
  errPhoto: 'The photo could not be saved.',
  errPhotoId: 'The photo was stored but no id came back.',
  pasteWhere: 'Click a field on the operation first, then paste — that is the row it goes to.',
  errExport: 'Export failed ({{status}})',
  errOpen: 'Could not open it',
  errSave: 'Save failed',
  errSaveStatus: 'Save failed ({{status}})',
  errDelete: 'Delete failed',
  errCopy: 'Copy failed',
  errRead: 'Could not read that file',
  savedAsText: '(saved as text)',
  tabDocs: 'OPA documents',
  tabSummary: 'SCT summary',
  tabActual: 'SCT vs actual',
  newOpa: 'New OPA',
  importXlsx: 'Import .xlsx',
  search: 'Search style, doc no or season',
  clear: 'Clear',
  nSaved: '{{n}} saved',
  nOfM: '{{n}} of {{total}}',
  no: 'No',
  action: 'Action',
  showSkus: 'Show the SKUs this OPA covers',
  view: 'View',
  edit: 'Edit',
  dupTitle: 'Duplicate — a new document with the same operations, version + 1',
  exportExcel: 'Export Excel',
  exportPdf: 'Export PDF',
  delete: 'Delete',
  nothingSaved: 'Nothing saved yet.',
  back: 'Back',
  viewOnly: 'View only',
  unsaved: 'Unsaved changes',
  saveChanges: 'Save changes',
  save: 'Save',
  building: 'Building…',
  fStyleName: 'Style name',
  fVariant: 'Variant',
  fCategory: 'Category',
  fSeason: 'Season',
  fSkus: 'SKUs',
  skuAdd: '+ Add',
  pickTitle: 'Pick the styles this OPA covers',
  skuSearch: 'Search style name / SAP code / SKU / color…',
  picked: 'Picked ({{n}})',
  hSku: 'SKU',
  hSap: 'SAP code',
  hStyle: 'Style name',
  hColor: 'Color',
  hUsedBy: 'Used by',
  searching: 'Searching…',
  nothingPicked: 'Nothing picked yet.',
  noFert: 'No matching FERT material.',
  fertNote: 'FERT materials only, first 200 matches — narrow with the search box. A greyed row already belongs to the OPA named beside it.',
  nPicked: '{{n}} picked',
  nPickedShowing: '{{n}} picked — showing them',
  done: 'Done',
  fEff: 'Style efficiency',
  fIndirect: 'Indirect rate',
  indirectHint: '0.25 = +25%.',
  fFrameFit: 'Frame-fit (min)',
  fFrameAss: 'Frame assembly (min)',
  fPackaging: 'Packaging (min)',
  fDate: 'Date',
  fVersion: 'Version',
  sumVar: 'Variable Sewing Cycles',
  secSecs: '{{name}} — {{n}} sec',
  sumStd: 'Standard Work Subtotal',
  sumFrameFit: 'Frame-fit',
  sumFrameAss: 'Frame ass.',
  sumPackaging: 'Packaging',
  opsSecs: '{{n}} ops · {{s}} sec',
  pickForBlock: 'Pick for a standard block',
  hNo: 'No.',
  hStages: 'Stages',
  hStagesVn: 'Công Đoạn',
  hNeedle: 'Type of Needle',
  hMachine: 'Type of Machine',
  hLength: 'Length (cm)',
  hPartQty: 'Part (QTY)',
  hCtPart: 'CT / part (sec)',
  hCt: 'CT (sec)',
  hardTitle: 'Most difficult process',
  hHard: 'Hard',
  photoTitle: 'One photo per operation',
  hPhoto: 'Photo',
  pickOp: 'Pick operation {{n}}',
  viewPhoto: 'View the photo',
  opN: 'Operation {{n}}',
  removePhoto: 'Remove the photo from this operation',
  addPhoto: 'Add a photo of this operation',
  moveUp: 'Move up',
  moveDown: 'Move down',
  removeOp: 'Remove this operation',
  noOpsIn: 'No operations in {{sec}} yet.',
  pasteHint: 'Screenshot on the clipboard? Click any field on the operation, then {{keys}} — the picture attaches to that row without saving a file first.',
  addOpTo: 'Add an operation to {{sec}}',
  tickFirst: 'Tick the operations first',
  saveAsBlockN: 'Save {{n}} as a standard block',
  saveAsBlock: 'Save as a standard block',
  noBlockYet: 'No standard block saved yet',
  insertBlock: 'Insert a standard block',
  mostDifficult: 'Most difficult process:',
  tickHard: 'Tick {{hard}} on the rows that are difficult.',
  maxTake: 'Max take time process:',
  noTimed: 'No timed operation yet.',
  chartsAppear: 'Charts appear once there are operations with a cycle time.',
  photos: 'Photos',
  saveFirst: 'Save the document first — a photo needs it to hang off.',
  importTitle: 'What came out of the file',
  importNote: 'Nothing is saved yet. Click a sheet to load it into the form and check it — or tick several and save them all at once, to go through them afterwards.',
  selectSheet: 'Select {{sheet}}',
  sheetMeta: '{{style}} · {{season}} · {{n}} operations',
  noSeason: 'no season',
  noOpaSheet: 'No OPA sheet in that file.',
  bulkSaved_one: '{{count}} document saved. It is in the list behind this box — the chart pictures appear once it has been opened and saved.',
  bulkSaved_other: '{{count}} documents saved. They are in the list behind this box — the chart pictures appear once each one has been opened and saved.',
  allSheets: 'All {{n}} sheets',
  savingNofM: 'Saving {{done}} of {{total}}…',
  saveSelectedN: 'Save {{n}} selected',
  saveSelected: 'Save selected',
  leaveTitle: 'Leave without saving?',
  leaveNote: 'This document has changes that have not been saved. Leaving now throws them away.',
  discard: 'Discard changes',
  keepEditing: 'Keep editing',
  skuViewTitle: 'SKUs this OPA covers',
  loading: 'Loading…',
  noSkus: 'No SKUs on this document.',
  nSkus: '{{n}} SKUs',
  close: 'Close',
  dropBlockTitle: 'Remove this standard block?',
  dropBlockNote_one: '{{count}} operation. It stops being offered when inserting. Documents already built from it keep their rows — those were copied, not linked.',
  dropBlockNote_other: '{{count}} operations. It stops being offered when inserting. Documents already built from it keep their rows — those were copied, not linked.',
  cancel: 'Cancel',
  remove: 'Remove',
  opsFrom: '{{n}} operations from {{sec}}',
  name: 'Name',
  noteOpt: 'Note (optional)',
  notePlaceholder: 'Which styles this belongs to',
  blank: '(blank)',
  saveBlock: 'Save block',
  copiedInto: 'copied into {{sec}} — editable afterwards',
  blockSearch: 'Search a block, a note, or an operation inside one…',
  hBlock: 'Block',
  hOps: 'Ops',
  hNote: 'Note',
  hSavedBy: 'Saved by',
  hideOps: 'Hide the operations',
  showOps: 'Show the operations',
  insertTicked: 'Insert the ticked operations',
  insertAll: 'Insert every operation in this block',
  insert: 'Insert',
  insertN: 'Insert {{n}}',
  addTickedTo: 'Add the {{n}} operation(s) ticked in this document to {{block}}',
  tickInDocFirst: 'Tick operations in the document first',
  add: 'Add',
  addN: 'Add {{n}}',
  removeFromLib: 'Remove from the library',
  allOpsInBlock: 'All operations in this block',
  hNeedleShort: 'Needle',
  hMachineShort: 'Machine',
  hLengthShort: 'Length',
  hQty: 'Qty',
  hCtPartShort: 'CT / part',
  takeOp: 'Take operation {{n}}',
  removeOpFrom: 'Remove this operation from {{block}}',
  noOpsInBlock: 'No operations in this block.',
  noBlockMatch: 'No block matches "{{q}}".',
  altOperation: 'Operation',
  delTitle: 'Delete this OPA?',
  delNote: 'It comes off the list. The operations are kept in the database, so it can be brought back if this turns out to be a mistake.',
};

const ko = {
  col: {
    docNo: '문서',
    styleName: '스타일',
    season: '시즌',
    line: '라인',
    plCategory: '카테고리',
    category: '문서 유형',
    skuCount: 'SKU',
    version: '버전',
    created: '생성일',
    createdBy: '생성자',
    updated: '수정일',
    updatedBy: '수정자',
  },
  errLoadList: '목록을 불러오지 못했습니다',
  errSaveBlock: '블록을 저장하지 못했습니다',
  errRemove: '삭제하지 못했습니다',
  errUpdateBlock: '블록을 수정하지 못했습니다',
  errPhoto: '사진을 저장하지 못했습니다.',
  errPhotoId: '사진은 저장되었지만 ID가 돌아오지 않았습니다.',
  pasteWhere: '먼저 공정의 입력란을 클릭한 뒤 붙여넣으세요 — 그 행에 들어갑니다.',
  errExport: '내보내기 실패 ({{status}})',
  errOpen: '열지 못했습니다',
  errSave: '저장 실패',
  errSaveStatus: '저장 실패 ({{status}})',
  errDelete: '삭제 실패',
  errCopy: '복제 실패',
  errRead: '파일을 읽지 못했습니다',
  savedAsText: '(텍스트로 저장됨)',
  tabDocs: 'OPA 문서',
  tabSummary: 'SCT 요약',
  tabActual: 'SCT 대 실적',
  newOpa: '새 OPA',
  importXlsx: '.xlsx 가져오기',
  search: '스타일, 문서 번호, 시즌 검색',
  clear: '초기화',
  nSaved: '{{n}}개 저장됨',
  nOfM: '{{total}}개 중 {{n}}개',
  no: 'No',
  action: '작업',
  showSkus: '이 OPA가 적용되는 SKU 보기',
  view: '보기',
  edit: '수정',
  dupTitle: '복제 — 같은 공정으로 새 문서를 만들고 버전 + 1',
  exportExcel: '엑셀 내보내기',
  exportPdf: 'PDF 내보내기',
  delete: '삭제',
  nothingSaved: '저장된 문서가 없습니다.',
  back: '뒤로',
  viewOnly: '보기 전용',
  unsaved: '저장하지 않은 변경 사항',
  saveChanges: '변경 사항 저장',
  save: '저장',
  building: '만드는 중…',
  fStyleName: '스타일명',
  fVariant: '변형',
  fCategory: '카테고리',
  fSeason: '시즌',
  fSkus: 'SKU',
  skuAdd: '+ 추가',
  pickTitle: '이 OPA가 적용되는 스타일 선택',
  skuSearch: '스타일명 / SAP 코드 / SKU / 색상 검색…',
  picked: '선택됨 ({{n}})',
  hSku: 'SKU',
  hSap: 'SAP 코드',
  hStyle: '스타일명',
  hColor: '색상',
  hUsedBy: '사용 중인 문서',
  searching: '검색 중…',
  nothingPicked: '선택한 항목이 없습니다.',
  noFert: '일치하는 FERT 자재가 없습니다.',
  fertNote: 'FERT 자재만, 처음 200건까지 — 검색창으로 좁히세요. 회색 행은 옆에 표시된 OPA에 이미 속해 있습니다.',
  nPicked: '{{n}}개 선택',
  nPickedShowing: '{{n}}개 선택 — 선택 항목 표시 중',
  done: '완료',
  fEff: '스타일 효율',
  fIndirect: '간접 비율',
  indirectHint: '0.25 = +25%.',
  fFrameFit: '프레임 피팅 (분)',
  fFrameAss: '프레임 조립 (분)',
  fPackaging: '포장 (분)',
  fDate: '날짜',
  fVersion: '버전',
  sumVar: '가변 봉제 사이클',
  secSecs: '{{name}} — {{n}}초',
  sumStd: '표준 작업 소계',
  sumFrameFit: '프레임 피팅',
  sumFrameAss: '프레임 조립',
  sumPackaging: '포장',
  opsSecs: '공정 {{n}}개 · {{s}}초',
  pickForBlock: '표준 블록에 넣을 행 선택',
  hNo: 'No.',
  hStages: '공정 (EN)',
  hStagesVn: '공정 (VN)',
  hNeedle: '바늘 종류',
  hMachine: '기계 종류',
  hLength: '길이 (cm)',
  hPartQty: '부품 (수량)',
  hCtPart: 'CT / 부품 (초)',
  hCt: 'CT (초)',
  hardTitle: '가장 어려운 공정',
  hHard: '어려움',
  photoTitle: '공정당 사진 1장',
  hPhoto: '사진',
  pickOp: '공정 {{n}} 선택',
  viewPhoto: '사진 보기',
  opN: '공정 {{n}}',
  removePhoto: '이 공정에서 사진 제거',
  addPhoto: '이 공정의 사진 추가',
  moveUp: '위로',
  moveDown: '아래로',
  removeOp: '이 공정 삭제',
  noOpsIn: '{{sec}}에 아직 공정이 없습니다.',
  pasteHint: '클립보드에 스크린샷이 있나요? 공정의 아무 입력란이나 클릭한 뒤 {{keys}}를 누르세요 — 파일로 저장하지 않아도 그 행에 사진이 붙습니다.',
  addOpTo: '{{sec}}에 공정 추가',
  tickFirst: '먼저 공정을 선택하세요',
  saveAsBlockN: '{{n}}개를 표준 블록으로 저장',
  saveAsBlock: '표준 블록으로 저장',
  noBlockYet: '저장된 표준 블록이 없습니다',
  insertBlock: '표준 블록 삽입',
  mostDifficult: '가장 어려운 공정:',
  tickHard: '어려운 행에 {{hard}}를 체크하세요.',
  maxTake: '가장 오래 걸리는 공정:',
  noTimed: '시간이 입력된 공정이 아직 없습니다.',
  chartsAppear: '사이클 타임이 있는 공정이 생기면 차트가 나타납니다.',
  photos: '사진',
  saveFirst: '먼저 문서를 저장하세요 — 사진을 연결할 문서가 필요합니다.',
  importTitle: '파일에서 읽은 내용',
  importNote: '아직 아무것도 저장되지 않았습니다. 시트를 클릭하면 양식에 불러와 확인할 수 있고, 여러 개를 체크해 한 번에 저장한 뒤 나중에 확인할 수도 있습니다.',
  selectSheet: '{{sheet}} 선택',
  sheetMeta: '{{style}} · {{season}} · 공정 {{n}}개',
  noSeason: '시즌 없음',
  noOpaSheet: '이 파일에는 OPA 시트가 없습니다.',
  bulkSaved_one: '문서 {{count}}개를 저장했습니다. 이 창 뒤의 목록에 있으며, 차트 그림은 문서를 열어 저장하면 나타납니다.',
  bulkSaved_other: '문서 {{count}}개를 저장했습니다. 이 창 뒤의 목록에 있으며, 차트 그림은 각 문서를 열어 저장하면 나타납니다.',
  allSheets: '시트 {{n}}개 전체',
  savingNofM: '{{total}}개 중 {{done}}개 저장 중…',
  saveSelectedN: '선택한 {{n}}개 저장',
  saveSelected: '선택 항목 저장',
  leaveTitle: '저장하지 않고 나갈까요?',
  leaveNote: '이 문서에 저장하지 않은 변경 사항이 있습니다. 지금 나가면 사라집니다.',
  discard: '변경 사항 버리기',
  keepEditing: '계속 편집',
  skuViewTitle: '이 OPA가 적용되는 SKU',
  loading: '불러오는 중…',
  noSkus: '이 문서에는 SKU가 없습니다.',
  nSkus: 'SKU {{n}}개',
  close: '닫기',
  dropBlockTitle: '이 표준 블록을 삭제할까요?',
  dropBlockNote_one: '공정 {{count}}개. 삽입할 때 더 이상 표시되지 않습니다. 이 블록으로 만든 문서는 행을 그대로 유지합니다 — 연결이 아니라 복사된 것이기 때문입니다.',
  dropBlockNote_other: '공정 {{count}}개. 삽입할 때 더 이상 표시되지 않습니다. 이 블록으로 만든 문서는 행을 그대로 유지합니다 — 연결이 아니라 복사된 것이기 때문입니다.',
  cancel: '취소',
  remove: '삭제',
  opsFrom: '{{sec}}의 공정 {{n}}개',
  name: '이름',
  noteOpt: '메모 (선택)',
  notePlaceholder: '어떤 스타일에 해당하는지',
  blank: '(빈칸)',
  saveBlock: '블록 저장',
  copiedInto: '{{sec}}에 복사됨 — 이후 수정 가능',
  blockSearch: '블록, 메모, 또는 블록 안의 공정 검색…',
  hBlock: '블록',
  hOps: '공정',
  hNote: '메모',
  hSavedBy: '저장자',
  hideOps: '공정 숨기기',
  showOps: '공정 보기',
  insertTicked: '체크한 공정 삽입',
  insertAll: '이 블록의 모든 공정 삽입',
  insert: '삽입',
  insertN: '{{n}}개 삽입',
  addTickedTo: '이 문서에서 체크한 공정 {{n}}개를 {{block}}에 추가',
  tickInDocFirst: '먼저 문서에서 공정을 체크하세요',
  add: '추가',
  addN: '{{n}}개 추가',
  removeFromLib: '라이브러리에서 삭제',
  allOpsInBlock: '이 블록의 모든 공정',
  hNeedleShort: '바늘',
  hMachineShort: '기계',
  hLengthShort: '길이',
  hQty: '수량',
  hCtPartShort: 'CT / 부품',
  takeOp: '공정 {{n}} 가져오기',
  removeOpFrom: '{{block}}에서 이 공정 삭제',
  noOpsInBlock: '이 블록에는 공정이 없습니다.',
  noBlockMatch: '"{{q}}"와 일치하는 블록이 없습니다.',
  altOperation: '공정',
  delTitle: '이 OPA를 삭제할까요?',
  delNote: '목록에서 사라집니다. 공정은 데이터베이스에 남아 있어 실수였다면 되돌릴 수 있습니다.',
};

const vi = {
  col: {
    docNo: 'Số TL',
    styleName: 'Style',
    season: 'Mùa',
    line: 'Dòng hàng',
    plCategory: 'Danh mục',
    category: 'Loại tài liệu',
    skuCount: 'SKU',
    version: 'PB',
    created: 'Ngày tạo',
    createdBy: 'Người tạo',
    updated: 'Ngày cập nhật',
    updatedBy: 'Người cập nhật',
  },
  errLoadList: 'Không tải được danh sách',
  errSaveBlock: 'Không lưu được khối',
  errRemove: 'Không xóa được',
  errUpdateBlock: 'Không cập nhật được khối',
  errPhoto: 'Không lưu được ảnh.',
  errPhotoId: 'Ảnh đã được lưu nhưng không nhận lại được id.',
  pasteWhere: 'Hãy bấm vào một ô của công đoạn trước rồi mới dán — ảnh sẽ vào đúng dòng đó.',
  errExport: 'Xuất thất bại ({{status}})',
  errOpen: 'Không mở được',
  errSave: 'Lưu thất bại',
  errSaveStatus: 'Lưu thất bại ({{status}})',
  errDelete: 'Xóa thất bại',
  errCopy: 'Nhân bản thất bại',
  errRead: 'Không đọc được file này',
  savedAsText: '(lưu dạng chữ)',
  tabDocs: 'Tài liệu OPA',
  tabSummary: 'Tổng hợp SCT',
  tabActual: 'SCT so với thực tế',
  newOpa: 'OPA mới',
  importXlsx: 'Nhập .xlsx',
  search: 'Tìm style, số tài liệu hoặc mùa',
  clear: 'Xóa lọc',
  nSaved: 'Đã lưu {{n}}',
  nOfM: '{{n}} / {{total}}',
  no: 'STT',
  action: 'Thao tác',
  showSkus: 'Xem các SKU mà OPA này áp dụng',
  view: 'Xem',
  edit: 'Sửa',
  dupTitle: 'Nhân bản — tạo tài liệu mới với cùng các công đoạn, phiên bản + 1',
  exportExcel: 'Xuất Excel',
  exportPdf: 'Xuất PDF',
  delete: 'Xóa',
  nothingSaved: 'Chưa có gì được lưu.',
  back: 'Quay lại',
  viewOnly: 'Chỉ xem',
  unsaved: 'Có thay đổi chưa lưu',
  saveChanges: 'Lưu thay đổi',
  save: 'Lưu',
  building: 'Đang tạo…',
  fStyleName: 'Tên style',
  fVariant: 'Biến thể',
  fCategory: 'Danh mục',
  fSeason: 'Mùa',
  fSkus: 'SKU',
  skuAdd: '+ Thêm',
  pickTitle: 'Chọn các style mà OPA này áp dụng',
  skuSearch: 'Tìm tên style / mã SAP / SKU / màu…',
  picked: 'Đã chọn ({{n}})',
  hSku: 'SKU',
  hSap: 'Mã SAP',
  hStyle: 'Tên style',
  hColor: 'Màu',
  hUsedBy: 'Đang dùng ở',
  searching: 'Đang tìm…',
  nothingPicked: 'Chưa chọn gì.',
  noFert: 'Không có vật tư FERT nào khớp.',
  fertNote: 'Chỉ vật tư FERT, tối đa 200 kết quả đầu — thu hẹp bằng ô tìm kiếm. Dòng màu xám đã thuộc về OPA ghi bên cạnh.',
  nPicked: 'Đã chọn {{n}}',
  nPickedShowing: 'Đã chọn {{n}} — đang hiển thị',
  done: 'Xong',
  fEff: 'Hiệu suất style',
  fIndirect: 'Tỷ lệ gián tiếp',
  indirectHint: '0.25 = +25%.',
  fFrameFit: 'Gắn khung (phút)',
  fFrameAss: 'Lắp ráp khung (phút)',
  fPackaging: 'Đóng gói (phút)',
  fDate: 'Ngày',
  fVersion: 'Phiên bản',
  sumVar: 'Chu kỳ may biến đổi',
  secSecs: '{{name}} — {{n}} giây',
  sumStd: 'Tiểu tổng công việc chuẩn',
  sumFrameFit: 'Gắn khung',
  sumFrameAss: 'Lắp ráp khung',
  sumPackaging: 'Đóng gói',
  opsSecs: '{{n}} công đoạn · {{s}} giây',
  pickForBlock: 'Chọn để đưa vào khối chuẩn',
  hNo: 'STT',
  hStages: 'Công đoạn (EN)',
  hStagesVn: 'Công Đoạn (VN)',
  hNeedle: 'Loại kim',
  hMachine: 'Loại máy',
  hLength: 'Chiều dài (cm)',
  hPartQty: 'Chi tiết (SL)',
  hCtPart: 'CT / chi tiết (giây)',
  hCt: 'CT (giây)',
  hardTitle: 'Công đoạn khó nhất',
  hHard: 'Khó',
  photoTitle: 'Mỗi công đoạn một ảnh',
  hPhoto: 'Ảnh',
  pickOp: 'Chọn công đoạn {{n}}',
  viewPhoto: 'Xem ảnh',
  opN: 'Công đoạn {{n}}',
  removePhoto: 'Gỡ ảnh khỏi công đoạn này',
  addPhoto: 'Thêm ảnh cho công đoạn này',
  moveUp: 'Di chuyển lên',
  moveDown: 'Di chuyển xuống',
  removeOp: 'Xóa công đoạn này',
  noOpsIn: '{{sec}} chưa có công đoạn nào.',
  pasteHint: 'Có ảnh chụp màn hình trong clipboard? Bấm vào một ô bất kỳ của công đoạn, rồi nhấn {{keys}} — ảnh gắn vào dòng đó mà không cần lưu file trước.',
  addOpTo: 'Thêm công đoạn vào {{sec}}',
  tickFirst: 'Hãy tích chọn công đoạn trước',
  saveAsBlockN: 'Lưu {{n}} công đoạn thành khối chuẩn',
  saveAsBlock: 'Lưu thành khối chuẩn',
  noBlockYet: 'Chưa lưu khối chuẩn nào',
  insertBlock: 'Chèn khối chuẩn',
  mostDifficult: 'Công đoạn khó nhất:',
  tickHard: 'Tích {{hard}} ở các dòng khó.',
  maxTake: 'Công đoạn tốn thời gian nhất:',
  noTimed: 'Chưa có công đoạn nào được bấm giờ.',
  chartsAppear: 'Biểu đồ sẽ hiện khi có công đoạn có thời gian chu kỳ.',
  photos: 'Ảnh',
  saveFirst: 'Hãy lưu tài liệu trước — ảnh cần gắn vào tài liệu.',
  importTitle: 'Nội dung đọc được từ file',
  importNote: 'Chưa có gì được lưu. Bấm vào một sheet để đưa vào biểu mẫu và kiểm tra — hoặc tích nhiều sheet và lưu tất cả một lần, rồi kiểm tra sau.',
  selectSheet: 'Chọn {{sheet}}',
  sheetMeta: '{{style}} · {{season}} · {{n}} công đoạn',
  noSeason: 'không có mùa',
  noOpaSheet: 'File này không có sheet OPA nào.',
  bulkSaved_one: 'Đã lưu {{count}} tài liệu. Tài liệu nằm trong danh sách phía sau hộp này — hình biểu đồ sẽ có sau khi mở và lưu lại.',
  bulkSaved_other: 'Đã lưu {{count}} tài liệu. Chúng nằm trong danh sách phía sau hộp này — hình biểu đồ sẽ có sau khi mở và lưu lại từng tài liệu.',
  allSheets: 'Tất cả {{n}} sheet',
  savingNofM: 'Đang lưu {{done}} / {{total}}…',
  saveSelectedN: 'Lưu {{n}} mục đã chọn',
  saveSelected: 'Lưu mục đã chọn',
  leaveTitle: 'Rời đi mà không lưu?',
  leaveNote: 'Tài liệu này có thay đổi chưa được lưu. Rời đi bây giờ sẽ mất các thay đổi đó.',
  discard: 'Bỏ thay đổi',
  keepEditing: 'Tiếp tục sửa',
  skuViewTitle: 'Các SKU mà OPA này áp dụng',
  loading: 'Đang tải…',
  noSkus: 'Tài liệu này không có SKU nào.',
  nSkus: '{{n}} SKU',
  close: 'Đóng',
  dropBlockTitle: 'Xóa khối chuẩn này?',
  dropBlockNote_one: '{{count}} công đoạn. Khối sẽ không còn được gợi ý khi chèn. Các tài liệu đã tạo từ khối này vẫn giữ các dòng của mình — chúng được sao chép, không liên kết.',
  dropBlockNote_other: '{{count}} công đoạn. Khối sẽ không còn được gợi ý khi chèn. Các tài liệu đã tạo từ khối này vẫn giữ các dòng của mình — chúng được sao chép, không liên kết.',
  cancel: 'Hủy',
  remove: 'Xóa',
  opsFrom: '{{n}} công đoạn từ {{sec}}',
  name: 'Tên',
  noteOpt: 'Ghi chú (không bắt buộc)',
  notePlaceholder: 'Khối này dùng cho style nào',
  blank: '(trống)',
  saveBlock: 'Lưu khối',
  copiedInto: 'sao chép vào {{sec}} — có thể sửa sau',
  blockSearch: 'Tìm khối, ghi chú hoặc công đoạn bên trong khối…',
  hBlock: 'Khối',
  hOps: 'Công đoạn',
  hNote: 'Ghi chú',
  hSavedBy: 'Người lưu',
  hideOps: 'Ẩn các công đoạn',
  showOps: 'Xem các công đoạn',
  insertTicked: 'Chèn các công đoạn đã tích',
  insertAll: 'Chèn mọi công đoạn trong khối này',
  insert: 'Chèn',
  insertN: 'Chèn {{n}}',
  addTickedTo: 'Thêm {{n}} công đoạn đã tích trong tài liệu này vào {{block}}',
  tickInDocFirst: 'Hãy tích công đoạn trong tài liệu trước',
  add: 'Thêm',
  addN: 'Thêm {{n}}',
  removeFromLib: 'Xóa khỏi thư viện',
  allOpsInBlock: 'Tất cả công đoạn trong khối này',
  hNeedleShort: 'Kim',
  hMachineShort: 'Máy',
  hLengthShort: 'Dài',
  hQty: 'SL',
  hCtPartShort: 'CT / chi tiết',
  takeOp: 'Lấy công đoạn {{n}}',
  removeOpFrom: 'Xóa công đoạn này khỏi {{block}}',
  noOpsInBlock: 'Khối này không có công đoạn nào.',
  noBlockMatch: 'Không có khối nào khớp "{{q}}".',
  altOperation: 'Công đoạn',
  delTitle: 'Xóa OPA này?',
  delNote: 'Tài liệu sẽ biến mất khỏi danh sách. Các công đoạn vẫn được giữ trong cơ sở dữ liệu, nên có thể khôi phục nếu đây là nhầm lẫn.',
};

const zh = {
  col: {
    docNo: '文档',
    styleName: '款式',
    season: '季',
    line: '产品线',
    plCategory: '类别',
    category: '文档类型',
    skuCount: 'SKU',
    version: '版本',
    created: '创建日期',
    createdBy: '创建人',
    updated: '更新日期',
    updatedBy: '更新人',
  },
  errLoadList: '无法加载列表',
  errSaveBlock: '无法保存该模块',
  errRemove: '无法移除',
  errUpdateBlock: '无法更新该模块',
  errPhoto: '照片无法保存。',
  errPhotoId: '照片已保存，但未返回 id。',
  pasteWhere: '请先点击该工序的任一输入框，再粘贴——照片会放到那一行。',
  errExport: '导出失败（{{status}}）',
  errOpen: '无法打开',
  errSave: '保存失败',
  errSaveStatus: '保存失败（{{status}}）',
  errDelete: '删除失败',
  errCopy: '复制失败',
  errRead: '无法读取该文件',
  savedAsText: '（以文本保存）',
  tabDocs: 'OPA 文档',
  tabSummary: 'SCT 汇总',
  tabActual: 'SCT 与实际对比',
  newOpa: '新建 OPA',
  importXlsx: '导入 .xlsx',
  search: '搜索款式、文档编号或季',
  clear: '清除',
  nSaved: '已保存 {{n}} 份',
  nOfM: '{{n}} / {{total}}',
  no: '序号',
  action: '操作',
  showSkus: '查看此 OPA 适用的 SKU',
  view: '查看',
  edit: '编辑',
  dupTitle: '复制——以相同工序新建文档，版本 + 1',
  exportExcel: '导出 Excel',
  exportPdf: '导出 PDF',
  delete: '删除',
  nothingSaved: '尚未保存任何内容。',
  back: '返回',
  viewOnly: '仅查看',
  unsaved: '有未保存的更改',
  saveChanges: '保存更改',
  save: '保存',
  building: '生成中…',
  fStyleName: '款式名称',
  fVariant: '变体',
  fCategory: '类别',
  fSeason: '季',
  fSkus: 'SKU',
  skuAdd: '+ 添加',
  pickTitle: '选择此 OPA 适用的款式',
  skuSearch: '搜索款式名称 / SAP 代码 / SKU / 颜色…',
  picked: '已选（{{n}}）',
  hSku: 'SKU',
  hSap: 'SAP 代码',
  hStyle: '款式名称',
  hColor: '颜色',
  hUsedBy: '已被使用',
  searching: '搜索中…',
  nothingPicked: '尚未选择。',
  noFert: '没有匹配的 FERT 物料。',
  fertNote: '仅限 FERT 物料，最多显示前 200 条——请用搜索框缩小范围。灰色行已属于旁边注明的 OPA。',
  nPicked: '已选 {{n}} 个',
  nPickedShowing: '已选 {{n}} 个——正在显示',
  done: '完成',
  fEff: '款式效率',
  fIndirect: '间接率',
  indirectHint: '0.25 = +25%。',
  fFrameFit: '套框（分钟）',
  fFrameAss: '框架组装（分钟）',
  fPackaging: '包装（分钟）',
  fDate: '日期',
  fVersion: '版本',
  sumVar: '可变缝制周期',
  secSecs: '{{name}} — {{n}} 秒',
  sumStd: '标准作业小计',
  sumFrameFit: '套框',
  sumFrameAss: '框架组装',
  sumPackaging: '包装',
  opsSecs: '{{n}} 道工序 · {{s}} 秒',
  pickForBlock: '选入标准模块',
  hNo: '序号',
  hStages: '工序（英）',
  hStagesVn: '工序（越）',
  hNeedle: '针型',
  hMachine: '机型',
  hLength: '长度 (cm)',
  hPartQty: '部件（数量）',
  hCtPart: 'CT / 部件（秒）',
  hCt: 'CT（秒）',
  hardTitle: '最难的工序',
  hHard: '难点',
  photoTitle: '每道工序一张照片',
  hPhoto: '照片',
  pickOp: '选择工序 {{n}}',
  viewPhoto: '查看照片',
  opN: '工序 {{n}}',
  removePhoto: '从此工序移除照片',
  addPhoto: '为此工序添加照片',
  moveUp: '上移',
  moveDown: '下移',
  removeOp: '删除此工序',
  noOpsIn: '{{sec}} 中尚无工序。',
  pasteHint: '剪贴板里有截图？点击该工序的任一输入框，然后按 {{keys}}——无需先保存文件，图片就会附到那一行。',
  addOpTo: '向 {{sec}} 添加工序',
  tickFirst: '请先勾选工序',
  saveAsBlockN: '将 {{n}} 道工序保存为标准模块',
  saveAsBlock: '保存为标准模块',
  noBlockYet: '尚未保存任何标准模块',
  insertBlock: '插入标准模块',
  mostDifficult: '最难的工序：',
  tickHard: '在较难的行上勾选 {{hard}}。',
  maxTake: '耗时最长的工序：',
  noTimed: '尚无计时的工序。',
  chartsAppear: '有带周期时间的工序后会显示图表。',
  photos: '照片',
  saveFirst: '请先保存文档——照片需要挂在文档上。',
  importTitle: '从文件中读取的内容',
  importNote: '尚未保存任何内容。点击一张工作表可载入表单进行核对——也可以勾选多张一次性全部保存，之后再逐一核对。',
  selectSheet: '选择 {{sheet}}',
  sheetMeta: '{{style}} · {{season}} · {{n}} 道工序',
  noSeason: '无季',
  noOpaSheet: '该文件中没有 OPA 工作表。',
  bulkSaved_one: '已保存 {{count}} 份文档。它在此窗口后面的列表中——打开并保存后才会出现图表图片。',
  bulkSaved_other: '已保存 {{count}} 份文档。它们在此窗口后面的列表中——逐一打开并保存后才会出现图表图片。',
  allSheets: '全部 {{n}} 张工作表',
  savingNofM: '正在保存 {{done}} / {{total}}…',
  saveSelectedN: '保存所选 {{n}} 项',
  saveSelected: '保存所选',
  leaveTitle: '不保存就离开？',
  leaveNote: '此文档有尚未保存的更改。现在离开将丢失这些更改。',
  discard: '放弃更改',
  keepEditing: '继续编辑',
  skuViewTitle: '此 OPA 适用的 SKU',
  loading: '加载中…',
  noSkus: '此文档没有 SKU。',
  nSkus: '{{n}} 个 SKU',
  close: '关闭',
  dropBlockTitle: '移除此标准模块？',
  dropBlockNote_one: '{{count}} 道工序。插入时将不再提供此模块。已用它建立的文档会保留各自的行——那些是复制的，不是链接。',
  dropBlockNote_other: '{{count}} 道工序。插入时将不再提供此模块。已用它建立的文档会保留各自的行——那些是复制的，不是链接。',
  cancel: '取消',
  remove: '移除',
  opsFrom: '来自 {{sec}} 的 {{n}} 道工序',
  name: '名称',
  noteOpt: '备注（可选）',
  notePlaceholder: '适用于哪些款式',
  blank: '（空白）',
  saveBlock: '保存模块',
  copiedInto: '复制到 {{sec}}——之后可编辑',
  blockSearch: '搜索模块、备注或模块中的工序…',
  hBlock: '模块',
  hOps: '工序',
  hNote: '备注',
  hSavedBy: '保存人',
  hideOps: '隐藏工序',
  showOps: '显示工序',
  insertTicked: '插入已勾选的工序',
  insertAll: '插入此模块的全部工序',
  insert: '插入',
  insertN: '插入 {{n}}',
  addTickedTo: '将此文档中已勾选的 {{n}} 道工序添加到 {{block}}',
  tickInDocFirst: '请先在文档中勾选工序',
  add: '添加',
  addN: '添加 {{n}}',
  removeFromLib: '从库中移除',
  allOpsInBlock: '此模块的全部工序',
  hNeedleShort: '针',
  hMachineShort: '机器',
  hLengthShort: '长度',
  hQty: '数量',
  hCtPartShort: 'CT / 部件',
  takeOp: '选取工序 {{n}}',
  removeOpFrom: '从 {{block}} 中移除此工序',
  noOpsInBlock: '此模块中没有工序。',
  noBlockMatch: '没有与 "{{q}}" 匹配的模块。',
  altOperation: '工序',
  delTitle: '删除此 OPA？',
  delNote: '它会从列表中移除。工序仍保留在数据库中，如属误删可以恢复。',
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "col": {
    "docNo": "Doc",
    "styleName": "Style",
    "season": "Saison",
    "line": "Ligne",
    "plCategory": "Catégorie",
    "category": "Type de doc",
    "skuCount": "SKU",
    "version": "Vers.",
    "created": "Créé le",
    "createdBy": "Créé par",
    "updated": "Modifié le",
    "updatedBy": "Modifié par"
  },
  "errLoadList": "Impossible de charger la liste",
  "errSaveBlock": "Impossible d'enregistrer le bloc",
  "errRemove": "Impossible de le supprimer",
  "errUpdateBlock": "Impossible de mettre à jour le bloc",
  "errPhoto": "La photo n'a pas pu être enregistrée.",
  "errPhotoId": "La photo a été stockée mais aucun identifiant n'a été renvoyé.",
  "pasteWhere": "Cliquez d'abord sur un champ de l'opération, puis collez — c'est la ligne qui la recevra.",
  "errExport": "Échec de l'export ({{status}})",
  "errOpen": "Impossible de l'ouvrir",
  "errSave": "Échec de l'enregistrement",
  "errSaveStatus": "Échec de l'enregistrement ({{status}})",
  "errDelete": "Échec de la suppression",
  "errCopy": "Échec de la copie",
  "errRead": "Impossible de lire ce fichier",
  "savedAsText": "(enregistré comme texte)",
  "tabDocs": "Documents OPA",
  "tabSummary": "Synthèse SCT",
  "tabActual": "SCT vs réel",
  "newOpa": "Nouvel OPA",
  "importXlsx": "Importer un .xlsx",
  "search": "Rechercher un style, un n° de doc ou une saison",
  "clear": "Effacer",
  "nSaved": "{{n}} enregistré(s)",
  "nOfM": "{{n}} sur {{total}}",
  "no": "N°",
  "action": "Action",
  "showSkus": "Afficher les SKU couverts par cet OPA",
  "view": "Afficher",
  "edit": "Modifier",
  "dupTitle": "Dupliquer — un nouveau document avec les mêmes opérations, version + 1",
  "exportExcel": "Exporter vers Excel",
  "exportPdf": "Exporter en PDF",
  "delete": "Supprimer",
  "nothingSaved": "Rien d'enregistré pour le moment.",
  "back": "Retour",
  "viewOnly": "Lecture seule",
  "unsaved": "Modifications non enregistrées",
  "saveChanges": "Enregistrer les modifications",
  "save": "Enregistrer",
  "building": "Génération…",
  "fStyleName": "Nom du style",
  "fVariant": "Variante",
  "fCategory": "Catégorie",
  "fSeason": "Saison",
  "fSkus": "SKU",
  "skuAdd": "+ Ajouter",
  "pickTitle": "Choisissez les styles couverts par cet OPA",
  "skuSearch": "Rechercher nom de style / code SAP / SKU / couleur…",
  "picked": "Sélectionnés ({{n}})",
  "hSku": "SKU",
  "hSap": "Code SAP",
  "hStyle": "Nom du style",
  "hColor": "Couleur",
  "hUsedBy": "Utilisé par",
  "searching": "Recherche…",
  "nothingPicked": "Rien de sélectionné pour le moment.",
  "noFert": "Aucun matériau FERT correspondant.",
  "fertNote": "Matériaux FERT uniquement, 200 premiers résultats — affinez avec la zone de recherche. Une ligne grisée appartient déjà à l'OPA indiqué à côté.",
  "nPicked": "{{n}} sélectionné(s)",
  "nPickedShowing": "{{n}} sélectionné(s) — affichage de la sélection",
  "done": "Terminé",
  "fEff": "Efficacité du style",
  "fIndirect": "Taux indirect",
  "indirectHint": "0,25 = +25 %.",
  "fFrameFit": "Montage du cadre (min)",
  "fFrameAss": "Assemblage du cadre (min)",
  "fPackaging": "Emballage (min)",
  "fDate": "Date",
  "fVersion": "Version",
  "sumVar": "Cycles de couture variables",
  "secSecs": "{{name}} — {{n}} s",
  "sumStd": "Sous-total travail standard",
  "sumFrameFit": "Montage du cadre",
  "sumFrameAss": "Assemblage cadre",
  "sumPackaging": "Emballage",
  "opsSecs": "{{n}} opér. · {{s}} s",
  "pickForBlock": "Choisir pour un bloc standard",
  "hNo": "N°",
  "hStages": "Étapes",
  "hStagesVn": "Công Đoạn",
  "hNeedle": "Type d'aiguille",
  "hMachine": "Type de machine",
  "hLength": "Longueur (cm)",
  "hPartQty": "Pièces (QTÉ)",
  "hCtPart": "CT / pièce (s)",
  "hCt": "CT (s)",
  "hardTitle": "Opération la plus difficile",
  "hHard": "Difficile",
  "photoTitle": "Une photo par opération",
  "hPhoto": "Photo",
  "pickOp": "Choisir l'opération {{n}}",
  "viewPhoto": "Afficher la photo",
  "opN": "Opération {{n}}",
  "removePhoto": "Retirer la photo de cette opération",
  "addPhoto": "Ajouter une photo de cette opération",
  "moveUp": "Monter",
  "moveDown": "Descendre",
  "removeOp": "Supprimer cette opération",
  "noOpsIn": "Aucune opération dans {{sec}} pour le moment.",
  "pasteHint": "Une capture d'écran dans le presse-papiers ? Cliquez sur un champ de l'opération, puis {{keys}} — l'image est jointe à cette ligne sans devoir d'abord enregistrer un fichier.",
  "addOpTo": "Ajouter une opération à {{sec}}",
  "tickFirst": "Cochez d'abord les opérations",
  "saveAsBlockN": "Enregistrer {{n}} comme bloc standard",
  "saveAsBlock": "Enregistrer comme bloc standard",
  "noBlockYet": "Aucun bloc standard enregistré pour le moment",
  "insertBlock": "Insérer un bloc standard",
  "mostDifficult": "Opération la plus difficile :",
  "tickHard": "Cochez {{hard}} sur les lignes difficiles.",
  "maxTake": "Opération au temps le plus long :",
  "noTimed": "Aucune opération chronométrée pour le moment.",
  "chartsAppear": "Les graphiques apparaissent dès qu'il y a des opérations avec un temps de cycle.",
  "photos": "Photos",
  "saveFirst": "Enregistrez d'abord le document — une photo doit y être rattachée.",
  "importTitle": "Contenu du fichier",
  "importNote": "Rien n'est encore enregistré. Cliquez sur une feuille pour la charger dans le formulaire et la vérifier — ou cochez-en plusieurs et enregistrez-les toutes d'un coup, pour les parcourir ensuite.",
  "selectSheet": "Sélectionner {{sheet}}",
  "sheetMeta": "{{style}} · {{season}} · {{n}} opérations",
  "noSeason": "pas de saison",
  "noOpaSheet": "Aucune feuille OPA dans ce fichier.",
  "bulkSaved_one": "{{count}} document enregistré. Il figure dans la liste derrière cette fenêtre — les images des graphiques apparaissent une fois qu'il a été ouvert et enregistré.",
  "bulkSaved_other": "{{count}} documents enregistrés. Ils figurent dans la liste derrière cette fenêtre — les images des graphiques apparaissent une fois que chacun a été ouvert et enregistré.",
  "allSheets": "Les {{n}} feuilles",
  "savingNofM": "Enregistrement de {{done}} sur {{total}}…",
  "saveSelectedN": "Enregistrer les {{n}} sélectionnés",
  "saveSelected": "Enregistrer la sélection",
  "leaveTitle": "Quitter sans enregistrer ?",
  "leaveNote": "Ce document contient des modifications non enregistrées. Si vous quittez maintenant, elles seront perdues.",
  "discard": "Abandonner les modifications",
  "keepEditing": "Continuer la modification",
  "skuViewTitle": "SKU couverts par cet OPA",
  "loading": "Chargement…",
  "noSkus": "Aucun SKU dans ce document.",
  "nSkus": "{{n}} SKU",
  "close": "Fermer",
  "dropBlockTitle": "Supprimer ce bloc standard ?",
  "dropBlockNote_one": "{{count}} opération. Il n'est plus proposé lors de l'insertion. Les documents déjà créés à partir de ce bloc conservent leurs lignes — elles ont été copiées, pas liées.",
  "dropBlockNote_other": "{{count}} opérations. Il n'est plus proposé lors de l'insertion. Les documents déjà créés à partir de ce bloc conservent leurs lignes — elles ont été copiées, pas liées.",
  "cancel": "Annuler",
  "remove": "Supprimer",
  "opsFrom": "{{n}} opérations issues de {{sec}}",
  "name": "Nom",
  "noteOpt": "Remarque (facultatif)",
  "notePlaceholder": "Les styles concernés",
  "blank": "(vide)",
  "saveBlock": "Enregistrer le bloc",
  "copiedInto": "copié dans {{sec}} — modifiable ensuite",
  "blockSearch": "Rechercher un bloc, une remarque ou une opération dans un bloc…",
  "hBlock": "Bloc",
  "hOps": "Opér.",
  "hNote": "Remarque",
  "hSavedBy": "Enregistré par",
  "hideOps": "Masquer les opérations",
  "showOps": "Afficher les opérations",
  "insertTicked": "Insérer les opérations cochées",
  "insertAll": "Insérer toutes les opérations de ce bloc",
  "insert": "Insérer",
  "insertN": "Insérer {{n}}",
  "addTickedTo": "Ajouter à {{block}} les {{n}} opération(s) cochée(s) dans ce document",
  "tickInDocFirst": "Cochez d'abord des opérations dans le document",
  "add": "Ajouter",
  "addN": "Ajouter {{n}}",
  "removeFromLib": "Retirer de la bibliothèque",
  "allOpsInBlock": "Toutes les opérations de ce bloc",
  "hNeedleShort": "Aiguille",
  "hMachineShort": "Machine",
  "hLengthShort": "Longueur",
  "hQty": "Qté",
  "hCtPartShort": "CT / pièce",
  "takeOp": "Prendre l'opération {{n}}",
  "removeOpFrom": "Retirer cette opération de {{block}}",
  "noOpsInBlock": "Aucune opération dans ce bloc.",
  "noBlockMatch": "Aucun bloc ne correspond à « {{q}} ».",
  "altOperation": "Opération",
  "delTitle": "Supprimer cet OPA ?",
  "delNote": "Il disparaît de la liste. Les opérations sont conservées dans la base de données : il pourra être rétabli s'il s'agit d'une erreur."
};
const ja = {
  "col": {
    "docNo": "文書",
    "styleName": "スタイル",
    "season": "シーズン",
    "line": "ライン",
    "plCategory": "カテゴリ",
    "category": "文書種別",
    "skuCount": "SKU 数",
    "version": "Ver",
    "created": "作成日",
    "createdBy": "作成者",
    "updated": "更新日",
    "updatedBy": "更新者"
  },
  "errLoadList": "一覧を読み込めませんでした",
  "errSaveBlock": "ブロックを保存できませんでした",
  "errRemove": "削除できませんでした",
  "errUpdateBlock": "ブロックを更新できませんでした",
  "errPhoto": "写真を保存できませんでした。",
  "errPhotoId": "写真は保存されましたが、ID が返されませんでした。",
  "pasteWhere": "まず工程のフィールドをクリックしてから貼り付けてください。その行に貼り付けられます。",
  "errExport": "エクスポートに失敗しました（{{status}}）",
  "errOpen": "開けませんでした",
  "errSave": "保存に失敗しました",
  "errSaveStatus": "保存に失敗しました（{{status}}）",
  "errDelete": "削除に失敗しました",
  "errCopy": "コピーに失敗しました",
  "errRead": "そのファイルを読み込めませんでした",
  "savedAsText": "（テキストとして保存）",
  "tabDocs": "OPA 文書",
  "tabSummary": "SCT サマリー",
  "tabActual": "SCT と実績",
  "newOpa": "新規 OPA",
  "importXlsx": ".xlsx をインポート",
  "search": "スタイル、文書番号、シーズンで検索",
  "clear": "クリア",
  "nSaved": "{{n}} 件保存済み",
  "nOfM": "{{n}} / {{total}}",
  "no": "No",
  "action": "操作",
  "showSkus": "この OPA が対象とする SKU を表示",
  "view": "表示",
  "edit": "編集",
  "dupTitle": "複製 — 同じ工程でバージョン + 1 の新しい文書を作成します",
  "exportExcel": "Excel にエクスポート",
  "exportPdf": "PDF にエクスポート",
  "delete": "削除",
  "nothingSaved": "保存されたものはまだありません。",
  "back": "戻る",
  "viewOnly": "閲覧のみ",
  "unsaved": "未保存の変更があります",
  "saveChanges": "変更を保存",
  "save": "保存",
  "building": "作成中…",
  "fStyleName": "スタイル名",
  "fVariant": "バリエーション",
  "fCategory": "カテゴリ",
  "fSeason": "シーズン",
  "fSkus": "SKU",
  "skuAdd": "+ 追加",
  "pickTitle": "この OPA の対象スタイルを選択してください",
  "skuSearch": "スタイル名 / SAP コード / SKU / カラーで検索…",
  "picked": "選択済み（{{n}}）",
  "hSku": "SKU",
  "hSap": "SAP コード",
  "hStyle": "スタイル名",
  "hColor": "カラー",
  "hUsedBy": "使用先",
  "searching": "検索中…",
  "nothingPicked": "まだ何も選択されていません。",
  "noFert": "該当する FERT 品目がありません。",
  "fertNote": "FERT 品目のみ、先頭200件を表示しています — 検索ボックスで絞り込んでください。グレーの行は、横に表示された OPA にすでに属しています。",
  "nPicked": "{{n}} 件選択",
  "nPickedShowing": "{{n}} 件選択 — 選択分を表示中",
  "done": "完了",
  "fEff": "スタイル効率",
  "fIndirect": "間接率",
  "indirectHint": "0.25 = +25%。",
  "fFrameFit": "フレーム取付（分）",
  "fFrameAss": "フレーム組立（分）",
  "fPackaging": "梱包（分）",
  "fDate": "日付",
  "fVersion": "バージョン",
  "sumVar": "可変縫製サイクル",
  "secSecs": "{{name}} — {{n}} 秒",
  "sumStd": "標準作業小計",
  "sumFrameFit": "フレーム取付",
  "sumFrameAss": "フレーム組立",
  "sumPackaging": "梱包",
  "opsSecs": "{{n}} 工程 · {{s}} 秒",
  "pickForBlock": "標準ブロック用に選択",
  "hNo": "No.",
  "hStages": "工程",
  "hStagesVn": "Công Đoạn",
  "hNeedle": "針の種類",
  "hMachine": "ミシンの種類",
  "hLength": "長さ（cm）",
  "hPartQty": "パーツ（数量）",
  "hCtPart": "CT / パーツ（秒）",
  "hCt": "CT（秒）",
  "hardTitle": "最も難しい工程",
  "hHard": "難",
  "photoTitle": "工程ごとに写真1枚",
  "hPhoto": "写真",
  "pickOp": "工程 {{n}} を選択",
  "viewPhoto": "写真を表示",
  "opN": "工程 {{n}}",
  "removePhoto": "この工程から写真を削除",
  "addPhoto": "この工程の写真を追加",
  "moveUp": "上へ移動",
  "moveDown": "下へ移動",
  "removeOp": "この工程を削除",
  "noOpsIn": "{{sec}} にはまだ工程がありません。",
  "pasteHint": "クリップボードにスクリーンショットがありますか？ 工程のフィールドをクリックして {{keys}} を押すと、ファイルを先に保存しなくても、その行に画像が添付されます。",
  "addOpTo": "{{sec}} に工程を追加",
  "tickFirst": "先に工程にチェックを入れてください",
  "saveAsBlockN": "{{n}} 件を標準ブロックとして保存",
  "saveAsBlock": "標準ブロックとして保存",
  "noBlockYet": "標準ブロックはまだ保存されていません",
  "insertBlock": "標準ブロックを挿入",
  "mostDifficult": "最も難しい工程：",
  "tickHard": "難しい行に {{hard}} をチェックしてください。",
  "maxTake": "所要時間が最大の工程：",
  "noTimed": "時間計測済みの工程はまだありません。",
  "chartsAppear": "サイクルタイムのある工程が入力されると、グラフが表示されます。",
  "photos": "写真",
  "saveFirst": "先に文書を保存してください — 写真は文書に紐づけるために必要です。",
  "importTitle": "ファイルの内容",
  "importNote": "まだ何も保存されていません。シートをクリックするとフォームに読み込んで確認できます。または複数にチェックを入れて一括保存し、後から確認することもできます。",
  "selectSheet": "{{sheet}} を選択",
  "sheetMeta": "{{style}} · {{season}} · {{n}} 工程",
  "noSeason": "シーズンなし",
  "noOpaSheet": "そのファイルに OPA シートがありません。",
  "bulkSaved_one": "{{count}} 件の文書を保存しました。このボックスの裏にある一覧に表示されます。グラフの画像は、開いて保存した後に表示されます。",
  "bulkSaved_other": "{{count}} 件の文書を保存しました。このボックスの裏にある一覧に表示されます。グラフの画像は、それぞれを開いて保存した後に表示されます。",
  "allSheets": "全 {{n}} シート",
  "savingNofM": "{{total}} 件中 {{done}} 件を保存中…",
  "saveSelectedN": "選択した {{n}} 件を保存",
  "saveSelected": "選択分を保存",
  "leaveTitle": "保存せずに移動しますか？",
  "leaveNote": "この文書には未保存の変更があります。今移動すると変更は失われます。",
  "discard": "変更を破棄",
  "keepEditing": "編集を続ける",
  "skuViewTitle": "この OPA が対象とする SKU",
  "loading": "読み込み中…",
  "noSkus": "この文書に SKU はありません。",
  "nSkus": "{{n}} SKU",
  "close": "閉じる",
  "dropBlockTitle": "この標準ブロックを削除しますか？",
  "dropBlockNote_one": "{{count}} 工程。挿入時の候補に表示されなくなります。このブロックから作成済みの文書は行をそのまま保持します — 行はリンクではなくコピーされているためです。",
  "dropBlockNote_other": "{{count}} 工程。挿入時の候補に表示されなくなります。このブロックから作成済みの文書は行をそのまま保持します — 行はリンクではなくコピーされているためです。",
  "cancel": "キャンセル",
  "remove": "削除",
  "opsFrom": "{{sec}} から {{n}} 工程",
  "name": "名前",
  "noteOpt": "備考（任意）",
  "notePlaceholder": "対象となるスタイル",
  "blank": "（空白）",
  "saveBlock": "ブロックを保存",
  "copiedInto": "{{sec}} にコピーしました — 後から編集できます",
  "blockSearch": "ブロック、備考、ブロック内の工程を検索…",
  "hBlock": "ブロック",
  "hOps": "工程数",
  "hNote": "備考",
  "hSavedBy": "保存者",
  "hideOps": "工程を隠す",
  "showOps": "工程を表示",
  "insertTicked": "チェックした工程を挿入",
  "insertAll": "このブロックのすべての工程を挿入",
  "insert": "挿入",
  "insertN": "{{n}} 件を挿入",
  "addTickedTo": "この文書でチェックした {{n}} 件の工程を {{block}} に追加",
  "tickInDocFirst": "先に文書内の工程にチェックを入れてください",
  "add": "追加",
  "addN": "{{n}} 件を追加",
  "removeFromLib": "ライブラリから削除",
  "allOpsInBlock": "このブロックのすべての工程",
  "hNeedleShort": "針",
  "hMachineShort": "ミシン",
  "hLengthShort": "長さ",
  "hQty": "数量",
  "hCtPartShort": "CT / パーツ",
  "takeOp": "工程 {{n}} を取り込む",
  "removeOpFrom": "この工程を {{block}} から削除",
  "noOpsInBlock": "このブロックに工程はありません。",
  "noBlockMatch": "「{{q}}」に一致するブロックはありません。",
  "altOperation": "工程",
  "delTitle": "この OPA を削除しますか？",
  "delNote": "一覧から外れます。工程はデータベースに残るため、誤って削除した場合は元に戻せます。"
};

const dictionary = { ns: 'xOpa', en, ko, vi, zh, fr, ja };

export default dictionary;
